export const queryRaisedReducer = (
    state = {
        queryRaisedListData: [],
        queryRaisedCount: 0
    },
    action
) => {
    switch (action.type) {
        case "QUERY_RAISED_LIST":
            return {
                ...state,
                queryRaisedListData: action.payload.list,
                queryRaisedCount: action.payload.count,

            };
        case "UPDATE_QUERY_STATUS":
            return {
                ...state,
                queryRaisedListData: state?.queryRaisedListData?.map((elem) => {
                    if (elem?._id == action?.payload?.query_id) {
                        return { ...elem, product_id: { ...elem?.product_id, status: action?.payload?.status, outcome: action?.payload?.outcome } }
                    }
                    return elem
                }),
            };
        default:
            return state;
    }
};
